import React from "react";
import { Link } from "react-router-dom";

const UserLink = ({
  text,
  className,
  disabled = false,
  onClick,
  icon,
  showIconFirst,
  value,
  title,
  href,
}) => {
  let btnText = showIconFirst ? (
    <span>
      {icon ? icon : ""} <span className="btext">{text}</span>
    </span>
  ) : (
    <span>
      <span className="btext">{text}</span> {icon ? icon : ""}
    </span>
  );
  return (
    <Link
      disabled={disabled}
      title={title}
      value={value}
      className={
        disabled ? "btn-disabled" : className ? className : "btn btn-primary"
      }
      onClick={onClick}
      to={href ? href : ""}
    >
      {btnText}
    </Link>
  );
};

export default UserLink;
